import { createFetch } from "@vueuse/core";

export default createFetch({
  baseUrl: "/api",
  options: {
    beforeFetch({ options }) {
      const headers = options.headers as Record<string, string>;
      headers["X-CSRF-Token"] = localStorage.getItem("csrf_token") ?? "";
      return { options };
    },
    afterFetch(context) {
      const csrfToken = context.response.headers.get("csrf_token");
      if (csrfToken != null) localStorage.setItem("csrf_token", csrfToken);
      return context;
    },
    onFetchError(ctx) {
      if (ctx.data?.errors) ctx.error = ctx.data.errors;
      else if (ctx.data?.error) ctx.error = ctx.data.error;
      return ctx;
    },
  },
});
